import React, { useEffect, useReducer } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, getRemotedbUrl,validateEmail, throwErrorEvent, shortenEtc } from '../../lib/ep.js';
import { v4 as uuidv4 } from 'uuid';
import { orderBy as _orderBy } from 'lodash';

import ActionLink from '../builder/ActionLink';
import ActionButton, { CreateButton, SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';
import { DeleteButton } from '../builder/ConfirmButton';
import EmailField from '../builder/EmailField';
import Input from '../builder/Input';
import FloatingLayer from '../builder/FloatingLayer';
import SaveButton from '../builder/SaveButton';
import Model from '../builder/Model';
import Message, { AlertMessage, SuccessMessage } from '../builder/Message';
import NavigationTabs from '../builder/NavigationTabs';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';
import Select from '../builder/Select';
import Spinner from '../builder/Spinner';
import StatsBarsH from '../builder/StatsBarsH';
import ToggleButton from '../builder/ToggleButton.js';
import Tooltip from '../builder/Tooltip.js';

import IconedSelectorItems from '../wrappers/IconedSelectorItems.js';

import EmailEdit from './EmailEdit';
import EmailSettings from './EmailSettings';
import PreviewEmail from './PreviewEmail.js';

import { email_types, getEmailTypes } from './EmailFilter';
import { isMultiStage } from '../../data/bootstrap_stages.js';
import OwnerPromoWrapper from '../ui_items/OwnerPromoWrapper.js';
import Module from '../ui_items/Module.js';
import ModuleHeader from '../ui_items/ModuleHeader.js';
import ExportModal from '../backend/ExportModal.js';
import { useOwner } from '../context/context.js';
import { defaults } from '../promotion/bootstrap.js';
import SinglePromoInsight from '../insights/SinglePromoInsight.js';

export const saveEmail = (promotion_id, email, cb) => {
	$.post(getRemotedbUrl(`/emails/save/${promotion_id}`), { email }, (result) => {
		if(cb != undefined) cb(result);
	}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
		throwErrorEvent(xhr.status);
	});
};

export const savePromotion = (promotion, cb) => {
	$.post(getRemotedbUrl(`/promotions/save/${promotion.id}`), promotion, (res) => {
		if(cb != undefined) cb();
	}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
		throwErrorEvent(xhr.status);
	});
};

const format_date = (window.is_spanish) ? 'DD-MM-YYYY' : 'YYYY-MM-DD';
const format_time = 'HH:mm:ss';
const debug_stats = false;
let stats_object = {
	total_sent:'20000',
	options:[
		{ name: "Índice de apertura", total:16372 },
		{ name: "Índice de clicks", total:2100 },
	],
	lasts:[
		{ email:'casa.jesus@hotmail.es', raw_date:'2021-12-02 11:09:02' },
		{ email:'casa.jesus@hotmail.es', raw_date:'2021-12-05 11:09:02' },
		{ email:'rochakely75@hotmail.com', raw_date:'2021-12-08 11:06:02' },
		{ email:'delriomillanandres@gmail.com', raw_date:'2021-12-14 11:06:02' },
		{ email:'loridey@msn.com', raw_date:'2021-12-14 11:04:02' },
		{ email:'joananglada31@gmail.com', raw_date:'2021-12-14 11:03:03' },
		{ email:'anatelletxeafernandez@gmail.com', raw_date:'2021-12-14 11:01:01' },
		{ email:'rambarplanells@gmail.com', raw_date:'2021-12-14 11:00:03' },
		{ email:'albertito35@gmail.com', raw_date:'2021-12-14 10:58:01' },
		{ email:'anamicodiez@gmail.com', raw_date:'2021-12-14 10:56:02' },
		{ email:'juantoledano10@hotmail.com', raw_date:'2021-12-14 10:56:02' },
	],
};

const search_object = [
	{
		"@timestamp": "2022-01-20T16:49:52.859Z",
		"email": "jordi@easypromosapp.com",
		"@version": "1",
		"ts": 1642696922,
		"opens": 1,
		"clicks": 0,
		"document_id": "30329081.1d7358084e9b43bb8f5e0a501fb88342",
		"smtp_events": [
			{
				"type": "sent",
				"diag": "250 2.0.0 OK  1642696931 x11si4633509ybt.594 - gsmtp",
				"source_ip": "198.2.136.57",
				"size": 20372,
				"ts": 1642696931,
				"destination_ip": "74.125.21.26"
			}
		],
		"state": "sent",
		"tags": [
			"default",
			"participate"
		],
		"elasticsearch_index": "delivered-2022-01-20",
		"subject": "Enhorabuena Jordi has conseguido 612.94 puntos!",
		"resends": [],
		"_id": "1d7358084e9b43bb8f5e0a501fb88342",
		"sender": "promos@photofun.realmadrid.com",
		"template": null,
		"opens_detail": [
			{
				"location": "Madrid, ES",
				"ua": "OS X/OS X/Apple Mail/Apple Mail",
				"ts": 1642697003,
				"ip": "88.26.242.219"
			}
		],
		"clicks_detail": []
	}
];

const defaultEmailValues = (props) => {
	const promotion = props.promotion ? props.promotion : [];
	const email_config = (promotion['email_config']) ? promotion['email_config'] : {};	//For old emails coming from Fluxe 2

	const display_in_notification = props.notification != undefined ? props.notification == '1' : false

	let default_values = {};
	default_values.id = uuidv4();
	default_values.type = props.type;
	default_values.promotion_id = promotion.id;
	default_values.notification = display_in_notification ? 1 : 0;
	default_values.subject = '';
	default_values.message = '';
	if(props.type == email_types.REGISTER || props.type == email_types.MANUAL || props.type == email_types.NEW_SCHEDULED || props.type == email_types.ON_REDEEM || props.type == email_types.WIN_PRIZE || props.type == email_types.REJECT_PRIZE || props.type == email_types.ON_TRANSACTION) default_values.stage_id = 0;	//Register
	default_values.config = {};

	if(props.promotion['email_fromname'] != undefined && props.promotion['email_fromname'] != '') {
		default_values.config.fromname = props.promotion['email_fromname'];
	} else if(email_config['fromname'] != undefined && email_config['fromname'] != '') {
		default_values.config.fromname = email_config['fromname'];
	} else {
		default_values.config.fromname = props.default_fromname;
	}
		
	if(props.promotion['email_replyto'] != undefined && props.promotion['email_replyto'] != '') {
		default_values.config.replyto = props.promotion['email_replyto'];
	} else if(email_config['reply_to'] != undefined && email_config['reply_to'] != ''){
		default_values.config.replyto = email_config['reply_to'];
	} else {
		default_values.config.replyto = props.default_replyto;
	}
	default_values.attachments = [];

	if(display_in_notification)default_values.config.email_notification = props.agent.email
	return default_values;
};

const Introduction = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	if(props.display_notifications){
		return (
			<div class="promo_short gui_not_in_top">
				<p>{i18n("Create notifications to receive emails based on the participation of your users")}.</p>
				<div class="gui_not_in_top_big">
					<strong>{i18n("What can you do?")}:</strong>
					<ul class="gui_checked_list">
						<li>{i18n("Receive a notification when a new user registers to the promotion")}.</li>
						<li>{i18n("Receive a notification when a user wins a prize")}.</li>
						<li>{i18n("Receive a notification when a user gets more than X points")}.</li>
						<li>{i18n("Create custom notifications based on the user registration data and based on their participation")}.</li>
						<li><ActionLink _target='_blank' _href={`${window.zendesk_base_url}4548305468436`} autotranslate={false}>{`${i18n("And much more")}...`}</ActionLink></li>
					</ul>
				</div>
			</div>
		)
	}

	return (
		<div class="promo_short gui_not_in_top">
			<p>{i18n("Create email templates to send to the participants based on conditions of their participation and registration data")}.</p>
			<div class="gui_not_in_top_big">
				<strong>{i18n("What can you do?")}:</strong>

				<ul class="gui_checked_list">
					<li>{i18n("Send an automatic email to the user when completes a participation")}.</li>

					<li>{i18n("Create conditions based on the user registration data (age, country) or based on their participation (points, prizes, number of entries, etc.)")}</li>

					<li>{i18n("Personalize the email content with your name, email address, signature and header image")}.</li>

					<li>{i18n("Write a message using variables (smart tags) to personalize the email depending on the information of each participant")}.</li>

					<li>{i18n("Attach up to 3 files in each email")}.</li>

					<li><ActionLink _target='_blank' _href={`${window.zendesk_base_url}4548305468436`} autotranslate={false}>{`${i18n("And much more")}...`}</ActionLink></li>
				</ul>
			</div>
		</div>
	)
};

const TypeSelector = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const display_in_notification = props.display_notifications;
	
	const createEmail = (type) => {
		props.dispatch({ type:'ADD_EMAIL', email_type:type, notification:display_in_notification ? 1 : 0 });
		self.location.href = `#${display_in_notification ? 'notification' : 'email'}/${type.mr}`;
		closeLayer();
	};

	const closeLayer = () => {
		props.dispatch({ type:'SHOW_SELECTOR' });
	};
	
	const label_title = display_in_notification ? i18n("What type of notification do you want to receive?") : i18n("What type of mail do you want to send?");

	return (
		<FloatingLayer _class={{size:'auto'}} backButton={() => closeLayer()}>
			<div class="without_actions">
				<SectionTitle autotranslate={false}>{label_title}</SectionTitle>
				<IconedSelectorItems 
					display_notifications={display_in_notification} 
					items={props.emailTypes} 
					onSelectItem={createEmail} 
					extra_classes='gui_not_in_top' />
			</div>
		</FloatingLayer>
	)
};

const EmailInList = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const promotion = props.promotion;

	const checkTotalUsers = (email) =>{
		$.ajax({
			url:getRemotedbUrl(`/emails/get_total/${promotion.id}/${email.id}`),
			type: "POST",
			timeout: 25000,
			dataType: 'json',
			success: (result) => {
				if(result.status){
					dispatchEmail({ type:'CHANGE', k:'total_manual_send', v:result.total });
				}
			},
			error: (x, t, m) => {
				console.error(x, t, m)
			}
		});
	}

	const [state, dispatchEmail] = useReducer((state, action) => {
		switch(action.type) {
			case 'CONFIRM_AND_SEND':
				const object = {display_confirm_and_send: state.display_confirm_and_send ? false : true};
				return { ...state, ...object };

			case 'SEND_A_TEST':
				let test = {
					display_test:(!state.display_test) ? true : false,
				};
				if(!test.display_test){
					test.sended_test = false;
				}
				return { ...state, ...test};

			case 'SENDED_TEST':
				return { ...state, sended_test:true };
			
			case 'SHOW_STATS':
				let obj = {
					display_stats:(!state.display_stats) ? true : false,
				};
				if(obj.display_stats) {
					obj.statying = true;
				} else {
					obj.stats = {};
				}

				return { ...state, ...obj };

			case 'SHOW_STATS_V24':
				return { ...state, display_stats_v24:action?.email ?? false };

			case 'SET_STATS':
				return { ...state, stats:action.stats, statying:false };

			case 'SHOW_PREVIEW':
				return { ...state, display_preview:(!state.display_preview) ? true : false, display_preview_selector : false, preview:(action.preview) ? action.preview : null };

			case 'SHOW_PREVIEW_SELECTOR':
				return { ...state, display_preview_selector:(!state.display_preview_selector) ? true : false};

			case 'CHANGE':
				return { ...state, [action.k]:action.v };

			case 'CHANGE_TEST':
				let obj2 = state.test;
				obj2[action.k] = action.v;
				return { ...state, test:obj2 };

			default:
				return state;
		}
	}, {
		total_manual_send:false,
		verify_send:null,
		manual_sended_at:false,
		manual_sending:false,
		deleting:false,
		copying:false,
		email:props.email,
		display_confirm_and_send: false,
		repeat:false,
		display_test:false,
		sended_test:false,
		display_preview:false,
		display_preview_selector:false,
		preview_prize_id:null,
		preview:null,
		test:{email:props.agent_email},
		statying:false,
		display_stats:debug_stats,
		display_stats_v24:debug_stats,
		stats:(debug_stats) ? stats_object : {},
	});

	useEffect(() => {
		if(!state.display_preview){
			dispatchEmail({ type:'CHANGE', k:'preview_prize_id', v:null });
		}
	}, [state.display_preview]);

	useEffect(() => {
		if(state.display_confirm_and_send){
			checkTotalUsers(state.email);
		}else{
			dispatchEmail({ type:'CHANGE', k:'total_manual_send', v:false });
		}
	}, [state.display_confirm_and_send]);

	const change = (k, v) => {
		dispatchEmail({ type:'CHANGE', k, v });
	};

	const changeTest = (k, v) => {
		dispatchEmail({ type:'CHANGE_TEST', k, v });
	};

	
	const send = (cb) => {
		const email_id = state.email.id;
		const promotion_id = state.email.promotion_id;
		dispatchEmail({ type:'CHANGE', k:'manual_sending', v:true });
		$.ajax({
			url:getRemotedbUrl(`/emails/new_manual/${promotion_id}/${email_id}`),
			type: "POST",
			timeout: 25000,
			dataType: 'json',
			success: (result) => {
				let state_email = state.email;
				state_email['sended_at'] = result.date;
				state_email['num_processed'] = result.total;
				dispatchEmail({ type:'CHANGE', k:'email', v:state_email });
				dispatchEmail({ type:'CHANGE', k:'manual_sended_at', v:result.email_to });
				dispatchEmail({ type:'CHANGE', k:'manual_sending', v:false });
				if(cb != undefined) cb();
			},
			error: (x, t, m) => {
			}
		});
	};

	const deleteEmail = () => {
		dispatchEmail({ type:'CHANGE', k:'deleting', v:true });

		$.post(getRemotedbUrl(`/emails/del/${state.email.id}`), (result) => {
			if(result.status) props.dispatch({ type:'DELETE_EMAILS', id:state.email.id });
			dispatchEmail({ type:'CHANGE', k:'deleting', v:false });
		}, 'JSON');
	};

	const toggleEmailStatus = () => {
		let email_tmp = state.email
		email_tmp.status = email_tmp.status == 1 ? 0 : 1;
		dispatchEmail({ type:'CHANGE', k:'email', v:email_tmp });
		saveEmail(promotion.id,email_tmp,(result) => {})
	};

	const copyEmail = () => {
		dispatchEmail({ type:'CHANGE', k:'copying', v:true });
		$.post(getRemotedbUrl(`/emails/copy_email/${promotion.id}`), { email:state.email }, (result) => {
			if(result.status) props.dispatch({ type:'COPY_EMAIL', email:result.email });
			dispatchEmail({ type:'CHANGE', k:'copying', v:false });
		}, 'JSON');
	};

	const statsEmail = () => {
		dispatchEmail({ type:'SHOW_STATS' });
		$.ajax({
			url: getRemotedbUrl(`/emails/statistics/${state.email.id}`),
			type: "POST",
			timeout: 30000,
			dataType: 'json',
			success: (response) => {
				if(response.status) {
					dispatchEmail({ type:'SET_STATS', stats:response });
				}else{
					dispatchEmail({ type:'SET_STATS', stats:{error:true} });
				}
			},
			error: (x, t, m) => {
				dispatchEmail({ type:'SET_STATS', stats:{error:true} });
			}
		});

	}

	const statsEmailv24 = (email) => {
		dispatchEmail({ type:'SHOW_STATS_V24', email });
	}

	const sendTest = (cb) => {
		let obj_to_send = {
			//email:state.test.email,
		};
		if(state.test.prize_type_id != undefined) obj_to_send.prize_type_id = state.test.prize_type_id;
		$.post(getRemotedbUrl(`/emails/new_test/${promotion.id}/${state.email.id}`), obj_to_send, (result) => {
			if(result.status){
				dispatchEmail({ type:'SENDED_TEST'});
			}
			if(cb != undefined) cb();
		}, 'JSON');
	};
	
	const config = state.email.config;
	const properties = (state.email.type != undefined) ? (props.emailTypes).find(e => e.type == state.email.type) : {};
	const is_manual = (state.email.type == email_types.MANUAL) ? true : false;
	const to_sent_in_bulk = (state.email.type == email_types.MANUAL || state.email.type == email_types.NEW_SCHEDULED) ? true : false;
	const role_designer = (props.role == 4) ? true : false;

	const not_valid_email = !properties;
	const edit_link =  `#edit/${state.email.id}`;
	const mail_stat_graphs_data = [];
	if(state.stats.options != undefined) {
		state.stats.options.map((bar) => {
			mail_stat_graphs_data.push({
				name:bar.name,
				value:bar.total,
			});
		});
	}

	let num_processed = state.email.num_processed > 0 ? state.email.num_processed : false;
	let datesend = state.email.datesend == undefined || state.email.datesend.includes('0000') ? false : state.email.datesend;
	let sended_at = state.email.sended_at == undefined || state.email.sended_at.includes('0000') ? false : state.email.sended_at;
	
	const prizes_in_subject = state.email.subject.includes('{{prize_summary') || state.email.subject.includes('{{prize_name') || state.email.subject.includes('{{prize_code');
	const prizes_in_message = state.email.message.includes('{{prize_summary') || state.email.message.includes('{{prize_name') || state.email.message.includes('{{prize_code');

	let prizes_for_test = [];
	let prizes_for_preview = [];
	let disabled_send_test = validateEmail(state.test.email) ? false : true;
	if(prizes_in_message || prizes_in_subject) {
		prizes_for_test.push({ k:null, v:`-- ${i18n("Select a prize")} --` });
		(props.prizes).map((item) => {
			if(state.email.type == email_types.ON_REDEEM && item.PrizeType.redeemable || state.email.type != email_types.ON_REDEEM){
				if(state.email.type != email_types.WIN_PRIZE){
					prizes_for_test.push({ k:item.PrizeType.id, v:item.PrizeType.title + (item.PrizeType.reference != undefined ? ' ('+item.PrizeType.reference+')' : '') });
					prizes_for_preview.push(item);
				}
			}
		});
		if(!disabled_send_test){
			disabled_send_test = state.test.prize_type_id != undefined ? false : true;
		}
	}

	const previewEmail = () => {
		if(prizes_for_preview.length > 1 && !state.preview_prize_id){
			dispatchEmail({ type:'SHOW_PREVIEW_SELECTOR' });
		}else{
			dispatchEmail({ type:'SHOW_PREVIEW', preview:state.email });
		}
	};

	let email_with_stage = props.stages.find((st) => st.Stage.id == state.email.stage_id);
	let link_stage = `/promotions/builder/${promotion.id}/#stages`;;
	let label_stage = (email_with_stage) ? (email_with_stage.Stage.display_title || `#${email_with_stage.Stage.id}`) : i18n("All participation stages");
	if(email_with_stage) link_stage += `/${state.email.stage_id}/options`;

	const blocked_email = to_sent_in_bulk && sended_at ? true : false;
	const deleted_email = state.email.status == '2' ? true : false;
	
	let tz = promotion.timezone;

	let _classes = [
		'gui_sortable_list_item',
		'gui_flexbox',
		'gui_flex_start',
		'gui_flex_col',
		'gui_flex_nowrap',
		'gui_flex_align_center',
		'gui_pos_rel',
	];
	if(!is_manual && state.email.status != '1') _classes.push('is_mail_disabled');

	let _conditions = config?.conditions || [];
	if(_conditions.length == undefined) {
		_conditions = Object.values(_conditions);	//is an object
	}
	const email_from_audience = _conditions.find((c) => c.condition == 'ids');
	const total_to_send = state?.total_manual_send ?? 0;
	const label_users_send = total_to_send + ' ' + (total_to_send == 1 ? i18n("User", 'lowercase') : i18n("users"));

	const send_verified_by_code = total_to_send > 10;
	const disabled_send = total_to_send === false || total_to_send === 0 || (send_verified_by_code && state.verify_send != total_to_send) ? true : false;

	return (
		<li class={_classes.join(" ")}>
			{(state.deleting || state.copying) && (
				<Spinner
					_class={{fullscreen:false}}
					force_bg={true}
					style={{zIndex:'8'}}
				>{(state.copying) ? "Copying" : "Deleting"}</Spinner>
			)}
			<div class="item_header gui_flex_space_between">
				<div class="item_title_container" style={{maxWidth:'auto'}}>
					<ActionLink
						_class={{ icon:properties?.icon ?? 'knk-alert redIcon gui_remove_pointer_events', other:'item_title cutTextOnOverflow' }}
						_href={edit_link}
						autotranslate={false}
					><span>{not_valid_email ? `[${i18n("Email not valid")}] ` : ''}<strong>{state.email.description}</strong></span></ActionLink>

					{(!to_sent_in_bulk && isMultiStage(promotion.promotion_type_id) && state.email.type != email_types.REGISTER && state.email.type != email_types.ON_REDEEM && state.email.type != email_types.ON_TRANSACTION) && (
						<ActionLink
							_class={{ other:'item_title cutTextOnOverflow'}}
							_href={link_stage}
							_target="_blank"
							autotranslate={false}
						><span>{i18n("Apply to") + ': '} <strong>{label_stage}</strong></span></ActionLink>
					)}

					<span class="in_column" style={{ marginLeft:'25px'}}>
						{(is_manual && sended_at) && (
							<span>{`${i18n("Sent on")} ${moment.tz(sended_at,"Europe/Madrid").tz(tz).format('L HH:mm')}`}</span>
						)}

						{(is_manual && !sended_at) && (
							<span>{i18n("Not sent yet")}</span>
						)}

						{(datesend) && (
							<span>{((num_processed) ? i18n("Sending date") : i18n("It will be sent")) + ' ' + EPDateFormat(datesend, 'L HH:mm')}</span>
						)}

						{(config.email_notification) ? (
							<>
								<em>{i18n("Notify")+': '+config.email_notification}</em>

								{(num_processed) && (
									(num_processed > 1) ? (
										<FormattedMessage id="Notification sent {total} times" values={{ total:num_processed }} />
									): (
										<FormattedMessage id="Notification sent" />
									)
								)}
							</>
						): (
							(num_processed) && (
								<FormattedMessage id="Email sent to {total} participants" values={{ total:num_processed }} />
							)
						)}

						<div class="gui_link_actions">
							{(promotion.status == '1' && !deleted_email && !blocked_email && !not_valid_email) && (
								<ActionLink
									onClick={() => dispatchEmail({ type:'SEND_A_TEST' })}
								>Send test email</ActionLink>
							)}

							{(is_manual && !deleted_email && !blocked_email && !not_valid_email) && (
								<ActionLink
									onClick={() => dispatchEmail({ type:'CONFIRM_AND_SEND' })}
								>Confirm & send</ActionLink>
							)}
						</div>
					</span>
				</div>

				<ButtonCollection>
					{(!is_manual && !not_valid_email) && (
						<ToggleButton
							squared={true}
							active={((state.email.status == '1') ? true : false)}
							icon='knk-slide-on greenIcon'
							icon_off='knk-slide-off redIcon'
							onClick={toggleEmailStatus}
							aria-label="Toggle status"
						/>
					)}

					{(!not_valid_email) && (
						<SquaredButton
							icon='knk-edit'
							_href={edit_link}
							aria-label="Edit"
						/>
					)}

					{(!role_designer && state.email.notification == 0 && !not_valid_email) && (
						<SquaredButton
							icon='knk-stats'
							//onClick={()=>statsEmailv24(state.email)}//Descomentar pk tiri de laravel
							onClick={statsEmail}//Old Email Stats
							tooltip={<Tooltip with_icon={false}>Statistics</Tooltip>}
							aria-label="View statistics"
						/>
					)}

					{(!email_from_audience && !not_valid_email) && (
						<SquaredButton
							icon='knk-copy'
							onClick={copyEmail}
							tooltip={<Tooltip with_icon={false}>Copy this email</Tooltip>}
							aria-label="Copy this email"
						/>
					)}

					{(!not_valid_email) && (
						<SquaredButton
							icon='knk-preview'
							onClick={previewEmail}
							tooltip={<Tooltip with_icon={false}>Preview an example</Tooltip>}
							aria-label="Preview an example"
						/>
					)}
					
					{(!blocked_email) && (
						<DeleteButton
							squared={true}
							onClick={deleteEmail}
						/>
					)}
				</ButtonCollection>
			</div>

			{(state.display_confirm_and_send) && (
				<FloatingLayer _class={{size:'small'}} enable_close={false}>
					<div>
						<SectionTitle _class={{icon:'knk-send'}} autotranslate={false}>{state.email.description}</SectionTitle>

						<SectionSubtitle autotranslate={false}>{`${i18n("Subject")}: ${state.email.subject}`}</SectionSubtitle>

						<SectionSubtitle autotranslate={false}>
						{(total_to_send === false) ? (
							<div class="gui_pos_rel gui_not_in_end gui_not_padded_in_start_big" style={{flexBasis:'25%'}}>
								<Spinner _class={{h_position:'left'}} />
								<span>{i18n("Verifying total number of users to be emailed")}</span>
							</div>
						): (
							<div>
								{(state.manual_sended_at) ? (
									<p>{`${i18n("When all emails have been processed, a notification will be sent to the email address of the user who created the promotion")}: `}<strong>{state.manual_sended_at}</strong></p>
								) : (
									<p dangerouslySetInnerHTML={{ __html:props.intl.formatMessage({ id:"This email will be sent to {total_users}" }, { total_users:`<strong class="redColor">${label_users_send}</strong>` })}} />
								)}
							</div>
						)}

						{(send_verified_by_code) && (
							<Message
								_class={{ other:'in_bottom' }}
							>
								<p>{i18n("Before sending this email, please make sure that the conditions applied, the subject and the body message are correct. Check that the number of users the email will be sent to is correct.")}</p>
								<p>{i18n("If you have already verified it and want to send the email now, enter in the following field the total number of users the email will be sent to.")}</p>
								<Input name="verify_send"  model={state} change={change} _class={{size:40}} error_msg_position_class="is_floating">Total number of users</Input>
							</Message>
						)}
						</SectionSubtitle>

						<ButtonCollection in_floating={true}>
							{(!state.manual_sended_at) && (
								<SaveButton
									disabled={disabled_send}
									onClick={(e, cb) => send(cb)}
								>Send</SaveButton>
							)}

							<ActionButton
								color='red'
								onClick={() => dispatchEmail({ type:'CONFIRM_AND_SEND'})}
							>Close</ActionButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}

			{(state.display_test) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => {dispatchEmail({ type:'SEND_A_TEST' });}}>
					{(!state.test.sended) && (
						<div>
							<SectionTitle>Send test email</SectionTitle>

							{(state.sended_test) ? (
								<SuccessMessage
									title={props.intl.formatMessage({ id:"Test email sent to {email}" }, { email:state.test.email })}
									_class={{ other:'in_top in_bottom' }}
								/>
							) : (
								<Model model={state.test} change={changeTest}>
									<p dangerouslySetInnerHTML={{ __html:props.intl.formatMessage({id:"For security reasons the test email will be sent to {email}"},{email:`<strong>${props.agent_email}</strong>`}) }} />
									{/*}
									<EmailField
										_class={{first:true}}
										name="email"
										state={state.test}
										value={state.test.email}
									>Enter an email address</EmailField>*/}

									{(prizes_for_test.length>0) && (
										<Select
											_class={{size:70}}
											name="prize_type_id"
											values={prizes_for_test}
										>Choose the prize</Select>
									)}
								</Model>
							)}

							<ButtonCollection in_floating={true}>
								{(state.sended_test) ? (
									<ActionButton
										color='red'
										onClick={() => dispatchEmail({ type:'SEND_A_TEST' })}
									>Close</ActionButton>
								) : (
									<SaveButton
										disabled={disabled_send_test}
										onClick={(e, cb) => sendTest(cb)}
									>Send</SaveButton>
								)}
							</ButtonCollection>
						</div>
					)}

					{(state.test.sended) && (
						<div class="without_actions">
							<SectionTitle>Test sended</SectionTitle>

							<SuccessMessage
								title="Verification OK"
								_class={{ other:'in_top in_bottom' }}
							>
								<p>{i18n("The email has been sent successfully")}</p>
							</SuccessMessage>
						</div>
					)}
				</FloatingLayer>
			)}

			{(state.display_preview_selector) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => dispatchEmail({ type:'SHOW_PREVIEW_SELECTOR' })}>
					{(!state.test.sended) && (
						<div>
							<SectionTitle>Preview an example</SectionTitle>
							<Model model={state.test} change={(k,v) => dispatchEmail({ type:'CHANGE', k, v })}>
								{(prizes_for_test.length>0) && (
									<Select
										name="preview_prize_id"
										values={prizes_for_test}
										_class={{ size:60, first:true }}
									>Choose the prize</Select>
								)}
							</Model>

							<ButtonCollection in_floating={true}>
								{(state.sended_test) ? (
									<ActionButton
										color='red'
										onClick={() => dispatchEmail({ type:'SHOW_PREVIEW_SELECTOR' }) }
									>Close</ActionButton>
								) : (
									<SaveButton
										disabled={!state.preview_prize_id}
										onClick={(e, cb) => previewEmail()}
									>Preview</SaveButton>
								)}
							</ButtonCollection>
						</div>
					)}
				</FloatingLayer>
			)}

			{(state.display_preview) && (
				<FloatingLayer backButton={() => dispatchEmail({ type:'SHOW_PREVIEW' })}>
					<div class="without_actions is_not_padded">
						<PreviewEmail
							promotion={promotion}
							prizes={prizes_for_preview}
							default_prize_id={state?.preview_prize_id ?? null}
							codesets={props.codesets}
							stage={(props.stages).find((e) => (e.id == state.email.stage_id))}
							subject={state.email.subject}
							configuration={state.email.config}>
							{state.email.message}
						</PreviewEmail>
					</div>
				</FloatingLayer>
			)}

			{(state.display_stats) && (
				<FloatingLayer _class={{size:'small'}} backButton={(e) => dispatchEmail({ type:'SHOW_STATS'})}>
					<div class="without_actions">
						<SectionTitle>Statistics</SectionTitle>

						<div class="email_stats_viewer">
							<section>
								<article class="container main_bg ep_form">
									{(state.statying) && (
										<Spinner _class={{fullscreen:false}} force_bg={true} style={{zIndex:'8'}}>Loading stats</Spinner>
									)}

									{(!state.stats.error) && (
										<>
											<div class="sent_emails_bars">
												<SectionSubtitle autotranslate={false}>{`${state.stats.total_sent} ${i18n("Emails sent")}`}</SectionSubtitle>

												<StatsBarsH
													data={mail_stat_graphs_data}
													total={state.stats.total_sent}
												/>
											</div>

											<div class="last_emails_list gui_not_in_top_big gui_not_in_bottom">
												<h3 class="title">{i18n("View the last emails sent")}</h3>

												{(state.stats.lasts != undefined && state.stats.lasts.length > 0) && (
													<ul class="list">
														{state.stats.lasts.map((e, i) => {
															return (
																<li key={`mail_stats_${i}`}>
																	<strong>{e.email}</strong>
																	<span>{EPDateFormat(EPGetUnix(e.raw_date), 'L, HH:mm')} h</span>
																</li>
															)
														})}
													</ul>
												)}
											</div>

											<span class="small_text gui_not_in_top">
												<FormattedMessage id="The email statistics are only available during {days} days once sent." values={{ days:30 }} />
											</span>
										</>
									)}

									{(state.stats.error) && (
										<AlertMessage>
											{props.intl.formatMessage({id:'The email statistics are only available during {days} days once sent.'},{days:30})}
										</AlertMessage>
									)}
								</article>
							</section>
						</div>
					</div>
				</FloatingLayer>
			)}
			{(state.display_stats_v24) && (
				<FloatingLayer backButton={(e) => dispatchEmail({ type:'SHOW_STATS_V24'})}>
					<div>
						<SinglePromoInsight
							type='promotion_emails'
							email_id={state.email.id}
							active={{
								key:'promotion_emails',
								icon:'knk-stats',
								title: `${i18n("Email")}: "${shortenEtc(state.display_stats_v24?.description,40) ?? i18n("Unknown")}"`,
							}}
							no_data_message = {`${i18n("No data")}<br/>${props.intl.formatMessage({id:'The email statistics are only available during {days} days once sent.'},{days:30})}`}
						/>
					</div>
				</FloatingLayer>
			)}
		</li>
	)
};

const Wrapper = (props) => {
	const disabled_menu = (props.route == undefined) ? true : false;
	const actual_section = (!disabled_menu) ? props.route.match.url : '';

	return (
		<OwnerPromoWrapper
			{...props}
			add_module={false}
			current_section="Emails & Notifications"
			menu="emails"
			selected={actual_section}
		>
			{props.children}
		</OwnerPromoWrapper>
	);
};

const EmailsPlatform = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const owner = useOwner();

	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type) {
			case 'SHOW_SEND_MANUAL':
				return { ...state, send_manual_email_id:(action.email_id > 0) ? action.email_id : null };

			case 'SHOW_SELECTOR':
				return { ...state, type_selector:(!state.type_selector) ? true : false };

			case 'SHOW_ERROR_STATS':
				return { ...state, error_stats:action.error_stats };

			case 'LOADING_EMAILS':
				return { ...state, loading_emails:(!state.loading_emails) ? true : false };

			case 'ADD_SEARCH_EMAILS':
				state.user_search.emails = action.emails;
				return { ...state, user_search:state.user_search };

			case 'SET_EMAILS':
				return { ...state, email:action.emails };
				
			case 'CHANGE':
				return { ...state, [action.k]:action.v };
		
			case 'CHANGE_EMAIL':
				for(var i in state.emails) {
					if(state.emails[i].id != action.id) continue;

					state.emails[i][action.k] = action.v;
					return { ...state, emails:[...state.emails] };
				}
				return state;

			case 'ADD_EMAIL':
				let type = action.email_type.type;
				let email_tmp = defaultEmailValues({ type, ...props, promotion:state.promotion,notification:action.notification });
				return { ...state, emails:[...state.emails, email_tmp] };

			case 'COPY_EMAIL':
				return { ...state, emails:[...state.emails, action.email] };
			
			case 'DELETE_EMAILS':
				return { ...state, emails:state.emails.filter((em) => (em.id != action.id)) };

			case 'SAVE_PROMOTION':
				return { ...state, promotion:action.promotion };

			default:
				return state;
		}
	}, {
		promotion:props.promotion.Promotion != undefined ? props.promotion.Promotion : [],
		emails:props.emails.map((e)=>{return e.EmailConfig != undefined ? e.EmailConfig : e}),
		type_selector:false,
		send_manual_email_id:null,
		email_search:'',
		user_search:{},
		loading_emails:false,
		error_stats:false,
		display_export:false,
	});

	const promotion = state.promotion;

	const changeEmail= (id, k, v) => {
		if(k == 'attachments') {
			if(!v || typeof v == 'object' && v.length == 0) v = [""]; //per post, us array buit no s'envia
		}

		dispatch({ type:'CHANGE_EMAIL', id, k, v });
	};

	const change = (k, v) => {
		dispatch({ type:'CHANGE', k, v });
	};

	const savePromo = (cb) => {
		let promotion = {...state.promotion,new_emails:true}
		savePromotion(promotion, () => {
			dispatch({ type:'SAVE_PROMOTION', promotion});
		});
	};
	
	if(props.trully_expired) {
		return (
			<Wrapper promo={promotion}>
				<Module
					title={{
						label:i18n("Promotion is closed"),
						icon:'knk-zipped redIcon',
					}}
					subtitle={`${i18n("You cannot send emails to participants")}.`}
					autotranslate={false}
					_class={{ other:'is_closed_functionality'}}
				>
					<ButtonCollection>
						<SecondaryButton
							_href={`/promotions/profile/${promotion.id}`}
							icon='knk-arrow-l-big'
							_class={{ other:'gui_not_in_top_small' }}
						>Back to profile</SecondaryButton>
					</ButtonCollection>
				</Module>
			</Wrapper>
		)
	}

	if(promotion.login_type == '3') {
		// ANONYMOUS MODE
		return (
			<Wrapper promo={promotion}>
				<Module
					title={{
						label:"Promotion is in anonymous mode",
						icon:'knk-zipped redIcon',
					}}
					subtitle={`${i18n("Emails and notifications are disabled in promotions with Anonymous Mode enabled")}.`}
					autotranslate={false}
					_class={{ other:'is_closed_functionality'}}
				>
					<ButtonCollection>
						<SecondaryButton
							_href={`/promotions/profile/${promotion.id}`}
							icon='knk-arrow-l-big'
							_class={{ other:'gui_not_in_top_small' }}
						>Back to profile</SecondaryButton>
					</ButtonCollection>
				</Module>
			</Wrapper>
		)
	}

	return (
		<Router hashType="noslash">
			<Route exact={true} path={['/', '/notifications']} render={(route) => {
				let display_in_notification = route.location.pathname == '/notifications' ? true : false;

				const emailTypes = getEmailTypes(props.intl, promotion, props.prizes, props.stages, display_in_notification);

				const _emails = (state.emails).filter((em) => { return em.notification == 0 && em.status != 2 && /^\d+$/.test(em.id)});
				const _notifications = (state.emails).filter((em) => { return em.notification == 1 && em.status != 2 && /^\d+$/.test(em.id)});
				
				const tabs = [{
					label:i18n("Emails to participants") + ((_emails.length > 0) ? ` [${_emails.length}]` : ' [0]' ),
					link:'',
					icon:'knk-email',
				}, {
					label:i18n("Notifications to administrators") + ((_notifications.length > 0) ? ` [${_notifications.length}]` : ' [0]' ),
					link:'notifications',
					icon:'knk-advice',
				}];
				
				const _list_elements = display_in_notification ? _notifications : _emails;
				const _label_create = display_in_notification ? i18n("Create a new notification") : i18n("Create a new email");

				return (
					<Wrapper route={route} promo={promotion}>
						<Module>
							<ModuleHeader
								custom_title={true}
								actions={
									<>
										{(!promotion.new_emails) && (
											<ActionButton
												onClick={(e, cb) => savePromo(cb)}
											>Activate Emails Platform</ActionButton>
										)}

										{(promotion.new_emails) && (
											<CreateButton
												onClick={() => dispatch({ type:'SHOW_SELECTOR' })}
												autotranslate={false}
											>{_label_create}</CreateButton>
										)}
									</>
								}
							>
								<NavigationTabs
									active={route.location.pathname}
									sections={tabs}
									display_type='tab'
									_class={{other:'is_not_bordered'}}
								/>
							</ModuleHeader>

							{(_list_elements.length > 0) ? (
								<ul class="gui_sortable_list gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_not_in_top_small">
									{(_list_elements).map((email, e) => {
										if(isNaN(email.id) || email.status == 2) return null;

										return (
											<EmailInList
												key={`email_${email.id}`}
												intl={props.intl}
												email={email}
												role={props.promotion_role}
												promotion={state.promotion}
												prizes={props.prizes}
												agent_email={props.agent.email}
												codesets={props.codesets}
												emailTypes={emailTypes}
												dispatch={dispatch}
												stages={props.stages}
											/>
										)
									})}
								</ul>
							) : (
								<Introduction
									{...props}
									display_notifications={display_in_notification}
								/>
							)}
							
							{(state.type_selector) && (
								<TypeSelector
									{...props}
									dispatch={dispatch}
									emailTypes={emailTypes}
									display_notifications={display_in_notification}
								/>
							)}
						</Module>
					</Wrapper>
				)
			}} />

			<Route exact={true} path={['/(email|notification)/:email_type', '/edit/:email_id']} render={(route) => {
				const email_id = route.match.params.email_id;
				//const email_type = route.match.params.email_type;
				const display_in_notification = route.match.params[0] == 'notification' ? true : false;
				const emailTypes = getEmailTypes(props.intl, promotion, props.prizes, props.stages, display_in_notification);

				let params_email = {
					intl:props.intl,
					change:changeEmail,
					emailTypes:emailTypes,
					promotion:state.promotion,
					cfs:props.cfs,
					languages:props.languages,
					segments:props.segments,
					stages:props.stages,
					prizes:props.prizes,
					emails:state.emails,
					default_fromname:props.default_fromname,
					default_replyto:props.default_replyto,
				};

				if(email_id != undefined) params_email.email = (state.emails).find((e) => (e.id == email_id));	// EDIT

				if(!email_id || params_email.email == undefined) {
					let dispatched_add_email = state.emails[state.emails.length - 1];
					if(state.emails.length == 0 || !isNaN(dispatched_add_email.id)) {
						window.location.hash = '/';
						return;
					} else {
						params_email.email = dispatched_add_email;
					}
				}

				const removeUnsavedEmails = (id, cb) => {
					dispatch({ type:'DELETE_EMAILS', id });
					if(cb != undefined) cb();
				};
			
				return (
					<Wrapper route={route} promo={promotion}>
						<EmailEdit
							{...params_email}
							removeUnsavedEmails={removeUnsavedEmails}
						/>
					</Wrapper>
				)
			}} />

			<Route exact={true} path='/settings' render={(route) => {
				return (
					<Wrapper route={route} promo={promotion}>
						<EmailSettings
							{...props}
							dispatch={dispatch}
						/>
					</Wrapper>
				)
			}} />

			<Route exact={true} path='/unsubscribed' render={(route) => {
				const total_unsubscribeds = (props.unsubscribeds != undefined) ? props.unsubscribeds.length : 0;

				return (
					<Wrapper route={route} promo={promotion}>
						<Module>
							<ModuleHeader
								subtitle={((props.unsubscribeds).length == 0) ? i18n("No users unsubscribed in this promotion") : null}
								autotranslate={false}
								icon="knk-download"
								actions={((props.unsubscribeds).length > 0) ? <ButtonCollection 
										_class={{ other:'gui_flex_end gui_not_in_bottom_small' }}
									>
										<ActionButton
											onClick={()=>change('display_export', true)}
											style={{ width:'100%' }}
										>Export</ActionButton>
									</ButtonCollection>
								: null}
							>{`${i18n("Users who unsubscribed in this promotion")}${total_unsubscribeds > 0 ? ': '+ total_unsubscribeds : ''}`}</ModuleHeader>

							{((props.unsubscribeds).length > 0) && (
								<ul class="simple_registered_entries_list" style={{overflow:'auto', maxHeight:'calc(100dvh - 345px)'}}>
									<li class="list_header single_item" style={{maxWidth:'877.5px'}}>
										<div class="tabled_item">
											<span class="entry_counter" />

											<span class="user_name">{i18n("Email")}</span>

											<span style={{flexBasis:'150px'}}>{i18n("Unsubscription date")}</span>
										</div>
									</li>

									{props.unsubscribeds.reverse().map((_u, i) => {
										let u = _u.EmailUnsubscribe;

										return (
											<li key={`unsuscribed_${i}`} class="single_item">
												<div class="tabled_item static_entry_info">
													<span class="entry_counter">
														<span class="counter">{i + 1}</span>
													</span>

													<span class="user_name">
														<ActionLink _href={`mailto:${u.email}`} autotranslate={false}>{u.email}</ActionLink>
													</span>

													<span style={{flexBasis:'150px'}}>{EPDateFormat(u.created, 'll, HH:mm')} h</span>
												</div>
											</li>
										)
									})}
								</ul>
							)}
						</Module>
						{(state.display_export) && (
							<ExportModal
								toggle={()=>change('display_export', false)}
								promotion={promotion}
								promotion_id={promotion.id}
								agent_email={owner?.agent?.Agent?.email ?? window.agent_email}
								type={"unsubscribed_emails"}
								title={`${i18n("Download Type")}: ${i18n("Unsubscribed Users")}`}
								filename={`unsubscribed_emails_${promotion.id}`}
							/>
						)}
					</Wrapper>
				)
			}} />

			<Route exact={true} path='/search' render={(route) => {
				const searchList = () => {
					dispatch({ type:'ADD_SEARCH_EMAILS', emails:[] });

					$.ajax({
						url:getRemotedbUrl(`/emails/search/${state.promotion.id}`),
						type: "POST",
						data: { email:state.email_search, type:'stats' },
						timeout: 25000,
						dataType: 'json',
						success: (result2) => {
							if(result2.emails != undefined) dispatch({ type:'ADD_SEARCH_EMAILS', emails:result2.emails });
							dispatch({ type:'LOADING_EMAILS' });
						},
						error: (x, t, m) => {
							dispatch({ type:'SHOW_ERROR_STATS',error_stats:true });
							dispatch({ type:'LOADING_EMAILS' });
						}
					});
				};
				
				const searchEmail = (cb) => {
					let emails = [];
					change('user_search', {});
					dispatch({ type:'SHOW_ERROR_STATS',error_stats:false });
					$.post(getRemotedbUrl(`/emails/search/${state.promotion.id}`), { email:state.email_search, type:'user' }, (result) => {
						change('user_search', result);
						if(debug_stats) {
							//Aixo per fer test a STATS, buscar qualsevol usuari que tinguis a la promo => PER FER PROVES buscant un usuari real a la teva DB
							dispatch({ type:'ADD_SEARCH_EMAILS', emails:search_object });
						}else{
							dispatch({ type:'LOADING_EMAILS' });
							searchList();
						}
						if(cb != undefined) cb();
					}, 'JSON');
				};

				const found = (state.user_search.status != undefined) ? state.user_search : false;
				let user = (found && found.user != undefined) ? found.user : {};
				let emails = (found.emails != undefined) ? _orderBy(found.emails, ['@timestamp'], ['desc']) : false;

				let unsubscribed = false;
				if(state.email_search) {
					unsubscribed = props.unsubscribeds.find((e) => e.EmailUnsubscribe.email == state.email_search);
					if(unsubscribed) unsubscribed = unsubscribed.EmailUnsubscribe;
				}
				const tz = promotion?.timezone ?? defaults.timezone;
				
				return (
					<Wrapper route={route} promo={promotion}>
						<Module
							title="Search Email Tool"
							actions={
								<>
									<Model classname="in_top" model={state} change={change} style={{width:'100%'}}>
										<EmailField
											name="email_search"
											value={state.email_search}
											_class={{first:true}}
											placeholder="Enter email"
										/>
									</Model>

									<SaveButton
										onClick={(e, cb) => searchEmail(cb)}
									>Search</SaveButton>
								</>
							}
						>
							{(found) && (
								<div class="gui_not_in_top">
									{(found.status == 1) ? (
										<ul class="mail_user_main_info">
											<li>
												<span>{i18n("***Name")}: <strong>{user.name}</strong></span>
												<span>{i18n("ID")}: #<strong>{user.login_id}</strong></span>
												<span>{i18n("Participations")}: <strong>{found.participations}</strong></span>
											</li>

											<li>
												{i18n("Email")}: <strong>{user.email}</strong>
												{(unsubscribed) && (
													<span>&nbsp;-&nbsp;
														<FormattedMessage id="This email was unsubscribed on {data}" values={{data:EPDateFormat(unsubscribed.created, `${format_date} ${format_time}`)}} />
													</span>
												)}
											</li>

											<li>
												<span>{i18n("Registration date")}: <strong>{EPGetTimezone(user.created,tz, 'LLLL')}</strong></span>
											</li>
										</ul>
									) : (
										<span>{i18n("No sent messages found to this email.")}</span>
									)}

									{(!state.loading_emails && emails.length > 0) && (
										<>
											<ul class="simple_registered_entries_list gui_not_in_top_big">
												<li class="list_header single_item" style={{maxWidth:'877.5px'}}>
													<div class="tabled_item">
														<span class="entry_counter" />

														<span style={{flexBasis:'60px'}}>{i18n("Status")}</span>

														<span class="user_name">{i18n("Subject")}</span>

														<span style={{flexBasis:'150px'}}>{i18n("Sending date")}</span>

														<span style={{flexBasis:'50px'}}>{i18n("Opens")}</span>

														<span style={{flexBasis:'50px'}}>{i18n("Clicks")}</span>
													</div>
												</li>
											</ul>

											<ul class="simple_registered_entries_list" style={{overflow:'auto', maxHeight:'calc(100dvh - 422px - 4.2em)'}}>
												{emails.map((email, i) => {
													let status = email?.state ?? 'unknown';

													let tooltip = false;
													let _color = 'greenBg';
													let _text = 'blackColor';

													switch(status) {
														case 'rejected':
															tooltip = email?.reject.reason || '';
															if(email.bounce_description != undefined) tooltip += ` (${email.bounce_description})`;
															_color = 'redBg';
															_text = 'whiteColor';
															break;

														case 'bounced':
															if(email.bounce_description != undefined) tooltip = email.bounce_description;
															_color = 'orangeBg';
															break;

														case 'soft-bounced':
															tooltip = email?.diag || '';
															if(email.bounce_description != undefined) tooltip += ` (${email.bounce_description})`;
															_color = 'orangeBg';
															break;

														case 'spam':
															status = "spam complaint";
															_color = 'orangeBg';
															break;

														case 'sent':
															status = "delivered";
															break;
													}

													return (
														<li key={`dest_${i}`} class="single_item">
															<div class="tabled_item static_entry_info">
																<span class="entry_counter">
																	<span class="counter">{i + 1}</span>
																</span>

																<span style={{flexBasis:'60px'}}>
																	<div class="gui_flexbox gui_flex_row gui_flex_align_center">
																		<span class="gui_ribbons">
																			<span class={`ribbon gui_text_nowrap in_top ${_color} ${_text}`} style={{top:'0'}}>{i18n(status)}</span>
																		</span>

																		{(tooltip) && (
																			<Tooltip>{tooltip}</Tooltip>
																		)}
																	</div>
																</span>

																<span class="user_name">
																	<h3 class="name">
																		<ActionLink _class={{other:'gui_cutTextOnOverflow gui_remove_pointer_events'}} autotranslate={false}>{email.subject}</ActionLink>
																	</h3>
																</span>

																<span style={{flexBasis:'150px'}}>{EPDateFormat(EPGetUnix(email['ts']), 'LLLL')}</span>

																<span style={{flexBasis:'50px'}}>{email?.opens || '0'}</span>

																<span style={{flexBasis:'50px'}}>{email?.clicks || '0'}</span>
															</div>
														</li>
													)
												})}
											</ul>
										</>
									)}
									
									{(state.loading_emails) && (
										<div class="gui_pos_rel" style={{height:'200px'}}>
											<Spinner
												_class={{fullscreen:false}}
												force_bg={true}
												color='#000000'
												style={{zIndex:'8'}}
											>Searching messages</Spinner>
										</div>
									)}

									{(state.error_stats) && (
										<AlertMessage
											title={i18n("An error has occurred. Please try again later.")}
											autotranslate={false}
											_class={{ other:'not_in_top' }}
										/>
									)}
								</div>
							)}

							{(!found) && (
								<p style={{minHeight:'220px', display:'flex', alignItems:'center', maxWidth:'80%', margin:'0 auto', textAlign:'center'}}>{i18n("Find all the messages sent to a specific email address. Use this tool to verify whether a message has been delivered, bounced, rejected or not sent due to unsubscription.")}</p>
							)}
						</Module>
					</Wrapper>
				)
			}} />
		</Router>
	)
}
export default injectIntl(EmailsPlatform);